import { existings } from '@Ravnur-Inc/nanoutils/filter';
import { keyById } from '@Ravnur-Inc/nanoutils/keyBy';
import { setup, Vue } from 'vue-class-component';

import MediaLinkItem from '../media-link-item/media-link-item';

import useSecurityStore from '@/store/security';
import { PortalPageType } from '@/types/Auth';
import { Media$Details } from '@/types/Media';
import { ApplicationTypes } from '@Ravnur-Inc/shared/types/Application';

import './media-links-list.scss';

const CN = 'media-links-list';

class Props {
  origin: Media$Details;
  pageType: PortalPageType;
}

export default class MediaLinksList extends Vue.with(Props) {
  private security = setup(() => useSecurityStore());
  private get isRootApplication() {
    return this.security.isRootApplication;
  }

  private get tenants() {
    return this.security.tenants;
  }

  private get currentApplication() {
    return this.security.currentApplication;
  }

  private get publicDomain() {
    return this.security.publicDomain;
  }

  private get portals() {
    const { origin, tenants, currentApplication, isRootApplication } = this;

    if (!isRootApplication) {
      return [currentApplication];
    }

    const cache = keyById(tenants);
    return origin.sites.map((id) => cache[id]);
  }

  render() {
    return this.pageType === PortalPageType.PUBLIC ? this.renderExternal() : this.renderTenants();
  }

  private renderExternal() {
    const { publicDomain, pageType, origin } = this;
    const app = {
      applicationType: ApplicationTypes.EXTERNAL,
      portalUrl: publicDomain,
    };

    return (
      <ul class={CN}>
        <MediaLinkItem application={app} media={origin} pageType={pageType} />
      </ul>
    );
  }

  private renderTenants() {
    const applications = existings(this.portals);

    return (
      <ul class={CN}>
        {applications.map((app) => {
          return (
            <MediaLinkItem
              key={app.id}
              application={app}
              media={this.origin}
              pageType={this.pageType}
            />
          );
        })}
      </ul>
    );
  }
}
